/**
 * 获取用户角色
 * @param {Object} userInfo 用户信息对象
 * @returns {string} 用户角色 (admin/doctor/pharmacist/user)
 */
function userCodeToRole(userInfo) {
  if (!userInfo || !userInfo.userCode) return 'user'
  if (userInfo.userCode.length !== 13) {
    return 'admin'
  } else {
    return userInfo.doctorType === '1' ? 'doctor' : (userInfo["pharmacistType"] === '1' ? 'pharmacist' : 'user')
  }
}

/**
 * 获取用户角色
 * @returns {string}
 */
export function getUserRole() {
  const user = JSON.parse(localStorage.getItem('user'))
  return userCodeToRole(user)
}

/**
 * 过滤路由函数
 * @param {Array} routes 路由配置数组
 * @param {string} userRole 用户角色
 * @returns {Array} 过滤后的路由配置
 */
export function filterRoutes(routes, userRole) {
  return routes.map(route => {
    const clonedRoute = { ...route }
    // 处理子路由
    if (clonedRoute.children) {
      clonedRoute.children = filterRoutes(clonedRoute.children, userRole)

      // 如果子路由全部被过滤，隐藏父路由
      if (clonedRoute.children.length === 0) {
        clonedRoute.hidden = true
      }
    }

    // 检查路由权限
    if (clonedRoute.meta && clonedRoute.meta.roles) {
      const hasPermission = clonedRoute.meta.roles.includes(userRole)

      // 如果没有权限，则隐藏该路由
      if (!hasPermission) {
        clonedRoute.hidden = true
      }
    }

    return clonedRoute
  })
}
